import React, { useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { ShopWithOwnerId } from 'graphql/user';
import { setCurrentShopInfo } from 'shared/Common';
import { useHistory } from 'react-router-dom';

export default function ShopList(props) {
  // props.userData
  const history = useHistory();
  const ownerId = window.localStorage.getItem('ownerId');

  const { data, refetch } = useQuery(ShopWithOwnerId, {
    variables: { ownerId: ownerId },
  });

  const goMainPage = (value) => {
    setCurrentShopInfo(value);
    if (props.onShopSelect) props.onShopSelect(value);
    if (props.onClose) props.onClose();
    history.replace('/main');
  };

  const renderShopList = (value, index) => {
    return (
      <button
        key={`btn-${index}`}
        className="justify-center items-center w-full h-16 font-bold text-white bg-primary mb-1"
        onClick={() => {
          goMainPage(value);
        }}>
        {value.shopTitle}
      </button>
    );
  };

  if (!data) return null;
  if (data && data.shopWithOwnerId && data.shopWithOwnerId.length === 1) {
    goMainPage(data.shopWithOwnerId[0]);
  }

  return (
    <div className="flex flex-col bg-cust-medium-gray items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none p-2">
      {data && data.shopWithOwnerId.map(renderShopList)}
    </div>
  );
}
